/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect, useState } from 'react';
import { eventUtil } from 'libs/mi-ui-library/src/utils/eventUtil';
import { useLazyQuery } from '@apollo/client';
import {
  phoenixLowestAvailableRates,
  phoenixOffersLowestAvailableRates,
  phoenixOfferParticipatingProperties,
  phoenixOfferParticipatingPropertiesMPOFlexibleDates,
  phoenixOfferProperties,
  phoenixOfferPropertiesFlexibleDates,
  phoenixOfferParticipatingPropertiesMarsha,
} from '@marriott/mi-offers-graphql';
import {
  getSearchResultQuery,
  getDTTSearchResultQuery,
  getCommaSeparator,
  getCalculatedDistance,
} from '../utils/helper';
import { addDaysToDate, getDateFormatted, getMPOFormattedDateNew } from '../utils/dateUtils';
import { PropertyCard } from '@marriott/mi-shop-components/src/molecules';
import { APPLICATION_BREAKPOINTS, useWindowSize, Text, Types } from '@marriott/mi-ui-library';
import { SkeletonOutletCardLoader } from 'libs/mi-rnb-components/src/organisms/SearchResults/SkeletonOutletCardLoader';
import { StyledPropertiesListWrapper } from './PropertiesListWrapper.styles';
import clsx from 'clsx';
import { shouldUseMockData, useGetBreakpoint } from '../../../../src/utils/CommonUtils';
import AlertNotification from 'libs/mi-ui-library/src/atoms/Alerts';
import { getUrlParam } from '../../OffersSearchForm/utils/OfferUtils';
import { RECENT_SEARCH_LIST_LIMIT } from '../../OffersSearchForm/constants/ApplicationConstants';
import { recentViewedPropertiesType } from './PropertiesListWrapper.types';
import {
  DAILY_TEXT,
  DESTINATION_FEE_CODE,
  FEEDESCRIPTION1,
  FEEDESCRIPTION2,
  FEEDESCRIPTION_DESTINATION,
  FEEDESCRIPTION_RESORT,
  MANDATORYFEE_TITLE,
  outputInterpolation,
  outputQuality,
  PARAM_PAGENO,
  RESORT_FEE_CODE,
  SURCHARGE_ORDINANCE_CODE,
  VIEW_RATE_LABEL,
  descriptionToDisplayOnPropertyCard,
} from '../../../../src/constants/OfferPropertiesListConstant';
import { Pagination } from '@marriott/mi-ui-library';
import { imgDimensionType, propertyCardDataType, searchDataType } from '../OfferPropertiesList.types';
import { PropertiesListFilter } from '../PropertiesListFilter';
import { BrandProps, ControlsProps, availableBrandsType } from '../PropertiesListFilter/PropertiesListFilter.types';
import moment from 'moment';
import { processAcceptLang } from '../../../utils/OfferUtils';
import {
  EXTERNAL_CTA_TYPE,
  HOTEL_VIEW,
  IMAGE_CACHE_DOMAIN,
  RZ_HOTEL_DOMAIN,
} from 'libs/mi-offers-components/src/constants/CommonConstants';
import { FormValuesContext } from '../../OffersSearchForm/index.contexts';
import { setDates } from '../../OffersSearchForm/store/store.actions';
import { DATES } from '../../OffersSearchForm/constants/StoreConstants';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { usePersistentGlobalStore } from '@marriott/mi-store-utils';
import axios from 'axios';
import { SortByFilterComponent } from '../../OffersSearchResults/sortByFilter';

export const PropertiesListWrapper: React.FC<any> = props => {
  const { formValues, setFormValues } = useContext(FormValuesContext);
  const mpoOffersFlexibleDate = JSON.parse(window.sessionStorage.getItem('mpoOffersFlexibleDates') ?? 'false');
  const isMobileViewPort = useGetBreakpoint() === 'mobile';
  const { width } = useWindowSize();
  const { offersData, isAuthorMode, model, customerId, currentLocale, sessionData, getOfferDataFromLightning } = props;
  const currentLocaleVal = currentLocale ?? 'en-US';
  const isPreview = offersData?.isPreview === 'true' ? true : false;
  const acceptLanguage = processAcceptLang(props?.acceptLanguage ?? '');
  const requestId = props?.requestId;
  const offerId = props?.offersData?.offerId;
  const offersRespObj = offersData?.responseObject;
  const stayStartDate = getOfferDataFromLightning
    ? offersRespObj?.offers?.[0]?.stayStartDate
    : offersRespObj?.edges?.[0]?.node?.stayStartDate;
  const minimumStay = getOfferDataFromLightning
    ? offersRespObj?.offers?.[0]?.minimumStay
    : offersRespObj?.edges?.[0]?.node?.minimumStay ?? 1;
  const defaultStartDate = getMPOFormattedDateNew(stayStartDate).currMPODate;
  const subdirectory = props?.subDirectoryVal ?? '';
  const variation = model?.variation;
  const hideReviews = acceptLanguage === 'zh-CN' ? true : false;
  const Enable_DTT_queries = props?.isDTT ? true : false;

  const clusterCode = getOfferDataFromLightning
    ? offersRespObj?.offers?.[0]?.clusterCode
    : offersRespObj?.edges?.[0].node.clusterCode;
  const showPoints = clusterCode === '39E' || clusterCode === 'MRW' || clusterCode === 'MW1' || clusterCode === 'P17';

  const [onloadInput, setOnloadInput] = useState<string>('');
  const [dataLoaderFlag, setDataLoaderFlag] = useState<boolean>(true);
  const [isNewFacetsLoading, setIsNewFacetsLoading] = useState<boolean>(false);
  const [pageCardCountInfo, setPageCardCountInfo] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { envVarsObject } = useClientEnvVarsStore();
  const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'] ?? IMAGE_CACHE_DOMAIN;
  let isResort = false;
  let isLACountyFee = false;
  //pagination
  let page = 1;
  let offset = 0;
  if (typeof window !== 'undefined') {
    const url = new URL(window?.location?.href, window?.location?.href); // Use the full URL
    const pageNo = url.searchParams.get(PARAM_PAGENO);
    page = parseInt(pageNo ? pageNo : '1');
    offset = (page - 1) * 40;
  }
  const [currentPage, setCurrentPage] = useState<number>(page);
  const [offsetValue, setOffsetValue] = useState<number>(offset);
  const basePath = acceptLanguage === 'zh-CN' ? '' : subdirectory ? `/${subdirectory}` : '/en-us';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateGlobalData = usePersistentGlobalStore((state: any) => state.updateGlobalData);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalData = usePersistentGlobalStore((state: any) => state.globalData);

  const getImageSetup = (): imgDimensionType => {
    let imageDimensions = {
      height: 288,
      width: 512,
    };
    if (Number(width) < APPLICATION_BREAKPOINTS['viewportL']) {
      imageDimensions = {
        height: 240,
        width: 360,
      };
    }
    if (Number(width) > APPLICATION_BREAKPOINTS['viewportL'] || Number(width) < APPLICATION_BREAKPOINTS['viewportS']) {
      imageDimensions = {
        height: 222,
        width: 715,
      };
    }
    return imageDimensions;
  };
  const getImageProps = (): string => {
    const imageDimensions = getImageSetup();
    const imgProp =
      `?output-quality=${outputQuality}&interpolation=${outputInterpolation};*,*&downsize=` +
      imageDimensions.width +
      'px:*';
    return imgProp;
  };
  const imageProperties = getImageProps();

  const onPageItemClick = (page: number): void => {
    if (!model.seoFriendlyPagination) {
      setDataLoaderFlag(true);
      const offset = (page - 1) * 40;
      setCurrentPage(page);
      setOffsetValue(offset);
      const targetSection = document.getElementById('offers-search-form')?.offsetTop;
      const isFixedHeader = document.body.classList.contains('fixed-header');
      window.scrollTo({
        top: targetSection ? (isFixedHeader ? targetSection - 50 : targetSection - 150) : 0,
        behavior: 'smooth',
      });
    }
  };

  // session update call
  const updateSessionObj = async (ariesOffer: any = {}) => {
    const sessionToken = typeof window !== 'undefined' ? globalData?.sessionData?.sessionToken : '';
    const currentOfferId = window?.location?.pathname ? window?.location?.pathname?.split('/').pop() : '';

    try {
      const url = '/mi/phoenix-gateway/v1/updateSession';
      const headers = {
        Cookie: `sessionID=${sessionToken}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      };
      const payload = {
        AriesOffer: { ...ariesOffer, AriesOfferId: currentOfferId },
        remove: [],
      };
      await axios
        .post(url, payload, {
          headers: headers,
        })
        .then((res: any) => {
          return res?.status;
        });
    } catch (error) {
      console.log(`OffersPropertiesList update session API Failed:, ${error}`); // eslint-disable-line no-console
    }
  };

  // utility to add filters to session
  const addFilterStateToSession = (
    selectedBrandsList: any,
    selectedCountriesList: any,
    selectedStatesList: any,
    selectedCitiesList: any,
    isTaxSliderActive?: boolean
  ) => {
    let ariesOffer: any = sessionData?.cacheData?.data?.AriesOffer;
    ariesOffer = {
      ...ariesOffer,
      selectedBrands: selectedBrandsList,
      selectedCountries: selectedCountriesList,
      selectedStates: selectedStatesList,
      selectedCities: selectedCitiesList,
      showPricesTax: isTaxSliderActive,
    };
    let updatedSessionData: any = sessionData;
    updatedSessionData = {
      ...updatedSessionData,
      cacheData: {
        ...updatedSessionData?.cacheData,
        data: {
          ...updatedSessionData?.cacheData?.data,
          AriesOffer: ariesOffer,
        },
      },
    };
    updateGlobalData('sessionData', updatedSessionData);
    updateSessionObj(ariesOffer);
  };

  const ariesOffer = globalData?.sessionData?.cacheData?.data?.AriesOffer ?? {};
  const ariesSessionOfferId = ariesOffer?.AriesOfferId;
  const currentOfferId = window?.location?.pathname ? window?.location?.pathname?.split('/').pop() : '';

  const [searchData, setSearchData] = useState<searchDataType>(
    ariesSessionOfferId === currentOfferId && ariesOffer?.searchData
      ? ariesOffer?.searchData
      : {
          latitude: '',
          longitude: '',
          startDate: defaultStartDate,
          endDate: addDaysToDate(defaultStartDate, minimumStay),
          countryCode: '',
          stateCode: '',
          childAges: [],
          numberInParty: 1,
          quantity: 1,
          includeMandatoryFees: true,
          flexible: '',
        }
  );
  const [propertyCardData, setPropertyCardData] = useState<propertyCardDataType>({
    hotels: [],
    totalProperties: 0,
  });

  const taxFlag = !isPreview
    ? false
    : acceptLanguage === 'en-US' && searchData?.countryCode != 'GB' && searchData?.countryCode != 'JP'
    ? false
    : true;
  const [showPricesTax, setShowPricesTax] = useState<boolean>(
    isPreview && ariesOffer && ariesOffer?.['showPricesTax'] ? ariesOffer?.['showPricesTax'] : taxFlag
  );

  //sort
  const sortBySessionVal = ariesOffer?.['sortBy'];
  const [sortBy, setSortBy] = useState(
    sortBySessionVal ??
      ((searchData?.latitude && searchData?.longitude) || searchData?.stateCode || searchData?.countryCode)
      ? 'OFFER_DISTANCE'
      : 'PROPERTY_NAME'
  );
  const sortOptions = [
    { sortByOptionTitle: `${model?.distanceLabel ?? 'Distance'}`, sortByOptionCode: 'OFFER_DISTANCE' },
  ];
  //brand filter
  const [availableBrands, setAvailableBrands] = useState<availableBrandsType[]>([]); // brands which are cominng as facets from uxl & available for selection
  const [selectedBrands, setSelectedBrands] = useState<BrandProps[]>(
    ariesSessionOfferId === currentOfferId ? ariesOffer?.['selectedBrands'] || [] : []
  ); // brands which are selected for filtering of list
  const [brandFacets, setBrandFacets] = useState<string[]>(selectedBrands.map((item: any) => item.code) || []);

  //country filter
  const [availableCountries, setAvailableCountries] = useState<ControlsProps[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<string[]>(
    ariesSessionOfferId === currentOfferId ? ariesOffer?.['selectedCountries'] ?? [] : []
  );
  const [countriesFacetList, setCountriesFacetList] = useState<string[]>(
    selectedCountries?.map((item: any) => item?.code) ?? []
  );

  //state filter
  const [availableStates, setAvailableStates] = useState<ControlsProps[]>([]);
  const [selectedStates, setSelectedStates] = useState<string[]>(
    ariesSessionOfferId === currentOfferId ? ariesOffer?.['selectedStates'] ?? [] : []
  );
  const [statesFacetList, setStatesFacetList] = useState<string[]>(
    selectedStates?.map((item: any) => item?.code) ?? []
  );

  //city filter
  const [availableCities, setAvailableCities] = useState<ControlsProps[]>([]);
  const [selectedCities, setSelectedCities] = useState<string[]>(
    ariesSessionOfferId === currentOfferId ? ariesOffer?.['selectedCities'] ?? [] : []
  );
  const [citiesFacetList, setCitiesFacetList] = useState<string[]>(
    selectedCities?.map((item: any) => item?.code) ?? []
  );
  const [updatePropertyCards, setUpdatePropertyCards] = useState(true);
  const paginationPanelLabel = {
    previous: model?.previous ?? '',
    next: model?.next ?? '',
  };
  //get onloadInput value
  useEffect(() => {
    setOnloadInput(getUrlParam());
  }, []);

  const trackingProperties = model?.trackingProperties;

  // Load Mock Data dynamically for DEV and AuthorMode
  const propertiesListUXLMockJson = async (isAuthorMode: boolean) => {
    if (shouldUseMockData(isAuthorMode)) {
      const propertiesListUXLMockJson = await import('../__mock__/OfferpropertiesListUXL.mock.json');
      return propertiesListUXLMockJson;
    }
    return {};
  };

  // clear filters from session when different offer is loaded in same browser window
  useEffect(() => {
    if (ariesSessionOfferId !== currentOfferId) {
      addFilterStateToSession([], [], [], [], showPricesTax);
    }
  }, []);

  useEffect(() => {
    setSortBy(
      (searchData?.latitude && searchData?.longitude) || searchData?.stateCode || searchData?.countryCode
        ? 'OFFER_DISTANCE'
        : 'PROPERTY_NAME'
    );
  }, [searchData?.latitude, searchData?.longitude, searchData?.stateCode, searchData?.countryCode]);

  // get properties list on page load
  useEffect(() => {
    if (typeof window === 'undefined') return; // Skip if server-side rendering
    //Check if any of the query params are present in the URL
    const hasQueryParams =
      window?.location?.search?.includes('selectedStateProvince') ||
      window?.location?.search?.includes('selectedCountry') ||
      window?.location?.search?.includes('selectedCity');

    //If lat and long are missing in searchData and query params are present, skip the call
    const shouldSkipCall =
      !((searchData.latitude && searchData.longitude) || searchData.countryCode || searchData.stateCode) &&
      hasQueryParams;

    if (shouldSkipCall) return;
    let payLoad: any;
    if (isPreview) {
      getPropertiesMarsha({
        variables: {
          offerPreviewId: String(offerId),
        },
      });
    } else {
      if (Enable_DTT_queries) {
        const inputVariable = getDTTSearchResultQuery(
          searchData,
          offerId,
          offsetValue,
          brandFacets,
          customerId,
          countriesFacetList,
          statesFacetList,
          citiesFacetList,
          sortBy,
          clusterCode
        );
        payLoad = {
          variables: {
            ...inputVariable,
          },
        };
      } else {
        const inputVariable = getSearchResultQuery(
          searchData,
          offerId,
          offsetValue,
          brandFacets,
          isPreview,
          customerId,
          countriesFacetList,
          statesFacetList,
          citiesFacetList,
          sortBy,
          [],
          clusterCode
        );
        payLoad = {
          variables: {
            ...inputVariable,
          },
        };
      }
      if (Enable_DTT_queries && (searchData?.flexible === 'on' || mpoOffersFlexibleDate)) {
        delete payLoad?.variables?.search;
      } else if (!Enable_DTT_queries && (searchData?.flexible === 'on' || mpoOffersFlexibleDate)) {
        delete payLoad?.variables?.larSearch;
      }
      getPropertiesListdata(payLoad);
    }
    setOffsetValue(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    searchData,
    currentPage,
    brandFacets,
    countriesFacetList,
    statesFacetList,
    citiesFacetList,
    updatePropertyCards,
    sortBy,
  ]);

  useEffect(() => {
    if (isAuthorMode) {
      const fetchAndProcessPropertyData = async (isAuthorMode: boolean) => {
        const rawPropertyData = await propertiesListUXLMockJson(isAuthorMode);

        const processedData = modifyPropertyCardData(rawPropertyData);
        const { hotels, totalProperties } = processedData;

        setPropertyCardData({ hotels, totalProperties });
        setDataLoaderFlag(false);
        setPageCardCountInfo(getPageCardCountInfo(totalProperties));

        const errorMessage = totalProperties === 0 ? model?.offerParticipatingPropertiesError : '';
        setErrorMessage(errorMessage);
      };

      fetchAndProcessPropertyData(isAuthorMode);
    }
    setOffsetValue(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyCardData, isAuthorMode]);

  //on click of apply filter button
  const handleApplyFilter = (
    updatePropertyCard: boolean,
    selectedBrandsList: any,
    selectedCountriesList: any,
    selectedStatesList: any,
    selectedCitiesList: any,
    isTaxSliderActive: boolean
  ) => {
    setUpdatePropertyCards(updatePropertyCard);
    setIsNewFacetsLoading(true);
    if (updatePropertyCard) {
      addFilterStateToSession(
        selectedBrandsList,
        selectedCountriesList,
        selectedStatesList,
        selectedCitiesList,
        isTaxSliderActive
      );
      setDataLoaderFlag(true);
    }
    //set selected brands for facet
    setSelectedBrands(selectedBrandsList);
    const brandFacetList = selectedBrandsList.map((item: any) => item.code);
    setBrandFacets(brandFacetList);
    //set selected countries for facet
    setSelectedCountries(selectedCountriesList);
    const countriesFacetList = selectedCountriesList?.map((item: any) => item?.code);
    setCountriesFacetList(countriesFacetList);
    //set selected states for facet
    setSelectedStates(selectedStatesList);
    const statesFacetList = selectedStatesList?.map((item: any) => item?.code);
    setStatesFacetList(statesFacetList);

    //set selected cities for facet
    setSelectedCities(selectedCitiesList);
    const citiesFacetList = selectedCitiesList?.map((item: any) => item?.code);
    setCitiesFacetList(citiesFacetList);

    if (isPreview) {
      setShowPricesTax(isTaxSliderActive);
    }

    if (updatePropertyCard) {
      //Remove pg query param from url
      const currentURL = new URL(window.location.href);
      if (currentURL.searchParams.has('pg')) {
        currentURL.searchParams.delete('pg');

        //update url without refresh
        window.history.replaceState({}, '', currentURL.toString());
      }
      setCurrentPage(1);
    }
  };
  const handleClearAllFilters = () => {
    setIsNewFacetsLoading(true);
    setUpdatePropertyCards(false);
    // addFilterStateToSession([]);
    setSelectedBrands([]);
    setBrandFacets([]);
    setSelectedCountries([]);
    setCountriesFacetList([]);
    setSelectedStates([]);
    setStatesFacetList([]);
    setSelectedCities([]);
    setCitiesFacetList([]);
    setCurrentPage(1);
    // setShowPricesTax(taxFlag);
  };

  // get properties list on search form update
  // Search Data Receive from Offers Search Form
  useEffect(() => {
    eventUtil.on('MPOSearchFormData', data => {
      setDataLoaderFlag(true);
      const searchFormData = data?.searchFormData;
      setSearchData(searchFormData);
      setCurrentPage(1);
      let ariesOffer: any = sessionData?.cacheData?.data?.AriesOffer;
      ariesOffer = {
        ...ariesOffer,
        selectedBrands: [],
        selectedCountries: [],
        selectedStates: [],
        selectedCities: [],
        searchData: data?.searchFormData,
      };
      let updatedSessionData: any = sessionData;
      updatedSessionData = {
        ...updatedSessionData,
        cacheData: {
          ...updatedSessionData?.cacheData,
          data: {
            ...updatedSessionData?.cacheData?.data,
            AriesOffer: ariesOffer,
          },
        },
      };
      updateGlobalData('sessionData', updatedSessionData);
      updateSessionObj(ariesOffer);
      setSelectedBrands([]);
      setBrandFacets([]);
      setSelectedCountries([]);
      setCountriesFacetList([]);
      setSelectedStates([]);
      setStatesFacetList([]);
      setSelectedCities([]);
      setCitiesFacetList([]);
    });

    eventUtil.on('childAgeErrFlag', flag => {
      setErrorMessage(flag ? model?.childAgeEmptyError : '');
    });

    eventUtil.on('stayDateMissingErrFlag', flag => {
      setErrorMessage(flag ? model?.stayDateEmptyError : '');
    });

    eventUtil.remove('MPOSearchFormData', () => {
      ('');
    });
    eventUtil.remove('childAgeErrFlag', () => {
      ('');
    });
    eventUtil.remove('stayDateMissingErrFlag', () => {
      ('');
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataLoaderFlag(true);
    eventUtil.on('DeepLinkUtil', data => {
      if (onloadInput) {
        setSearchData(data.searchFormData);
      }
    });
    eventUtil.remove('DeepLinkUtil', () => {
      ('');
    });
  }, [onloadInput]);

  const getPageCardCountInfo = (cardsTotalCount: number): string => {
    const total = Math.ceil(cardsTotalCount / 40);
    const start = total === 1 || currentPage === 1 ? 1 : (currentPage - 1) * 40 + 1;
    const end = total === currentPage || currentPage === cardsTotalCount ? cardsTotalCount : currentPage * 40;
    const countText = `${model?.showing} ${start}-${end} ${model?.of} ${cardsTotalCount} ${model?.hotel}`;
    return countText;
  };

  const processPropertiesMarsha = (propertiesMarsha: any) => {
    const marshCodes = propertiesMarsha?.offerPreview?.offer?.participatingProperties?.properties
      ?.slice(0, 40)
      ?.map((obj: { id: string }) => {
        return obj.id;
      });
    const clusterCode = propertiesMarsha?.offerPreview?.offer?.clusterCode ?? '';

    const inputVariable = getSearchResultQuery(
      searchData,
      offerId,
      offsetValue,
      brandFacets,
      isPreview,
      customerId,
      countriesFacetList,
      statesFacetList,
      citiesFacetList,
      sortBy,
      marshCodes,
      clusterCode
    );
    const payLoad = {
      variables: {
        ...inputVariable,
      },
    };
    getPropertiesListdata(payLoad);
  };
  const processPropertiesList = (propertiesListdata: any) => {
    if (propertiesListdata) {
      const modifiedPropertyCardData = Enable_DTT_queries
        ? modifyDTTPropertyCardData(propertiesListdata)
        : modifyPropertyCardData(propertiesListdata);
      const propertiesFacetsBucket = Enable_DTT_queries
        ? propertiesListdata?.marketing?.offers?.search?.facets
        : propertiesListdata?.offersSearch?.facets;
      variation === 'sbo' &&
        setSelectedBrands([
          {
            code: modifiedPropertyCardData?.hotels[0]?.brandCode,
            brandTagId: modifiedPropertyCardData?.hotels[0]?.brandCode,
            brandTagTitle: '',
            isDisabled: false,
          },
        ]);
      if (updatePropertyCards) {
        setPropertyCardData({
          hotels: modifiedPropertyCardData?.hotels,
          totalProperties: modifiedPropertyCardData.totalProperties ?? 0,
        });
      }

      // set available brands
      const uxlAvailableBrandData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
        return el?.type?.enumCode === 'BRANDS';
      });
      variation === 'sbo'
        ? setAvailableBrands([
            {
              code: modifiedPropertyCardData?.hotels[0]?.brandCode,
              description: modifiedPropertyCardData?.hotels[0]?.brandCode,
            },
          ])
        : setAvailableBrands(uxlAvailableBrandData?.[0]?.buckets);

      //set available countries
      const uxlAvailableCountriesData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
        return el?.type?.enumCode === 'COUNTRIES';
      });
      setAvailableCountries(uxlAvailableCountriesData?.[0]?.buckets);

      //set available states
      const uxlAvailableStatesData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
        return el?.type?.enumCode === 'STATES';
      });
      setAvailableStates(uxlAvailableStatesData?.[0]?.buckets);

      //set available cities
      const uxlAvailableCitiesData = propertiesFacetsBucket?.filter((el: { type: { enumCode: string } }) => {
        return el?.type?.enumCode === 'CITIES';
      });
      setAvailableCities(uxlAvailableCitiesData?.[0]?.buckets);
      setDataLoaderFlag(false);
      setIsNewFacetsLoading(false);
      if (updatePropertyCards) {
        setPageCardCountInfo(getPageCardCountInfo(modifiedPropertyCardData?.totalProperties));
        modifiedPropertyCardData?.totalProperties === 0
          ? setErrorMessage(model?.offerParticipatingPropertiesError)
          : setErrorMessage('');
      }
    }
  };
  const handlePropertiesError = () => {
    setIsNewFacetsLoading(false);
    if (updatePropertyCards) {
      setPageCardCountInfo(getPageCardCountInfo(0));
      setPropertyCardData({
        hotels: [],
        totalProperties: 0,
      });
      setDataLoaderFlag(false);
      setErrorMessage(
        propertiesListError?.networkError ? model?.apiFailureMessageLabel : model?.offerParticipatingPropertiesError
      );
    }
  };

  //fetch marsha codes for preview flow
  const [
    getPropertiesMarsha,
    { data: propertiesMarshadata, loading: propertiesMarshaLoading, error: propertiesMarshaError },
  ] = useLazyQuery(phoenixOfferParticipatingPropertiesMarsha, {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    context: {
      headers: {
        'x-request-id': requestId,
        'accept-language': acceptLanguage,
        ...(acceptLanguage === 'zh-CN' && { defaultLocale: 'false' }),
      },
    },
    onCompleted: processPropertiesMarsha,
  });

  //Error Handling of getPropertiesMarsha
  useEffect(() => {
    setDataLoaderFlag(true);
    if (propertiesMarshaError) {
      if (propertiesMarshadata) {
        processPropertiesMarsha(propertiesMarshadata);
      } else {
        handlePropertiesError();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertiesMarshadata, propertiesMarshaLoading, propertiesMarshaError]);

  //get properties list
  const [
    getPropertiesListdata,
    { data: propertiesListdata, loading: propertiesListLoading, error: propertiesListError },
  ] = useLazyQuery(
    isPreview
      ? Enable_DTT_queries
        ? phoenixOffersLowestAvailableRates
        : phoenixLowestAvailableRates
      : Enable_DTT_queries
      ? searchData?.flexible === 'on' || mpoOffersFlexibleDate
        ? phoenixOfferPropertiesFlexibleDates
        : phoenixOfferProperties
      : searchData?.flexible === 'on' || mpoOffersFlexibleDate
      ? phoenixOfferParticipatingPropertiesMPOFlexibleDates
      : phoenixOfferParticipatingProperties,
    {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
      context: {
        headers: {
          'x-request-id': requestId,
          'accept-language': acceptLanguage,
        },
      },
      onCompleted: processPropertiesList,
    }
  );

  //Error Handling of properties list
  useEffect(() => {
    if (updatePropertyCards && !propertiesListLoading) {
      setDataLoaderFlag(true);
    }
    if (propertiesListError) {
      if (propertiesListdata) {
        processPropertiesList(propertiesListdata);
      } else {
        handlePropertiesError();
      }
    } else if (propertiesListdata && !propertiesListLoading) {
      setIsNewFacetsLoading(false);
      processPropertiesList(propertiesListdata);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertiesListdata, propertiesListLoading, propertiesListError]);

  //modify card data helper functions
  const modifyPropertyCardData = (data: any) => {
    const propList = isPreview
      ? data?.searchLowestAvailableRatesByPropertyIds?.edges ?? []
      : data?.offersSearch?.edges[0]?.node.participatingProperties?.propertyRates ?? [];
    const clusterCode = isPreview
      ? data?.searchLowestAvailableRatesByPropertyIds?.edges[0]?.node?.rates[0]?.rateCategory
          ?.rateCategoryDescription[0]?.clusterCode ?? ''
      : data.offersSearch?.edges[0]?.node.clusterCode ?? '';
    const hotels = propList?.length
      ? propList.map((hotel: any) => {
          const {
            fullyRenovatedLabel,
            recentlyRenovatedLabel,
            newHotelLabel,
            adultsOnlyLabel,
            renovatedLobbyLabel,
            renovatedRoomsLabel,
          } = model || {};
          const basicInformation = isPreview
            ? hotel?.node?.property?.basicInformation
            : hotel?.property?.basicInformation || {};
          const isFullyRenovated = basicInformation?.isFullyRenovated;
          const isRecentlyRenovated = basicInformation?.isRecentlyRenovated;
          const hasRenovatedRooms = basicInformation?.hasRenovatedRooms;
          const newProperty = basicInformation?.newProperty;
          const isAdultsOnly = basicInformation?.isAdultsOnly;
          const newLobby = basicInformation?.newLobby;
          let ribbonDetails = null;

          if (isFullyRenovated) {
            ribbonDetails = {
              ribbonText: fullyRenovatedLabel,
              ribbonClass: 'fully-renovated-ribbon',
            };
          } else if (isRecentlyRenovated) {
            ribbonDetails = {
              ribbonText: recentlyRenovatedLabel,
              ribbonClass: 'recently-renovated-ribbon',
            };
          } else if (newProperty) {
            ribbonDetails = {
              ribbonText: newHotelLabel,
              ribbonClass: 'new-hotel-ribbon ribbon',
            };
          } else if (isAdultsOnly) {
            ribbonDetails = {
              ribbonText: adultsOnlyLabel,
              ribbonClass: 'adult-hotel-ribbon',
            };
          } else if (newLobby) {
            ribbonDetails = {
              ribbonText: renovatedLobbyLabel,
              ribbonClass: 'renovated-lobby-ribbon',
            };
          } else if (hasRenovatedRooms) {
            ribbonDetails = {
              ribbonText: renovatedRoomsLabel,
              ribbonClass: 'renovated-rooms-ribbon',
            };
          }
          if (isPreview) {
            return {
              id: hotel?.node?.property?.id ?? '',
              sid: hotel?.node?.property?.basicInformation?.marshaBrandCode ?? '',
              brandCode: hotel?.node?.property?.basicInformation?.brand?.id ?? '',
              titleDetails: getTitle(hotel?.node?.property, hotel?.node?.property?.basicInformation?.brand?.id),
              reviewsDetails: getReviewDetails(
                hotel?.node?.property,
                hotel?.node?.property?.basicInformation?.brand?.id,
                hotel?.node?.distance
              ),
              description: getDescriptionText(hotel?.node?.property?.basicInformation?.descriptions),
              images: getPropertyImages(hotel?.node?.property),
              tertiaryLinkDetails: generateDetailsPageURL(
                hotel?.node?.property?.seoNickname ?? '',
                hotel?.node?.property?.basicInformation?.brand?.id
              ),
              footerLinkDetails: getFooterDetails(hotel, clusterCode),
              mandatoryFeeObj: {
                amountPlusMandatoryFee: getAmountPlusMandatoryFeeDetails(hotel),
                mandatoryFee: getMandatoryFeeDetails(hotel),
                mandatoryFeeDescription: getMandatoryFeeDescription(hotel.property?.basicInformation?.descriptions),
                ...getMandatoryFeeMessages(),
              },
              brandDetails: {
                brandId: hotel?.node?.property?.basicInformation?.brand?.id,
                label: '',
                hasUniquePropertyLogo: hotel?.node?.property?.basicInformation?.hasUniquePropertyLogo,
              },
              ribbonDetails: ribbonDetails,
              addScrimToImage: true,
            };
          } else {
            return {
              id: hotel.property?.id ?? '',
              sid: hotel.property?.basicInformation?.marshaBrandCode ?? '',
              brandCode: hotel.property?.basicInformation?.brand?.id ?? '',
              titleDetails: getTitle(hotel.property, hotel?.property?.basicInformation?.brand?.id),
              reviewsDetails: getReviewDetails(
                hotel.property,
                hotel?.property?.basicInformation?.brand?.id,
                hotel?.distance
              ),
              description: getDescriptionText(hotel?.property?.basicInformation?.descriptions),
              images: getPropertyImages(hotel.property),
              tertiaryLinkDetails: generateDetailsPageURL(
                hotel?.property?.seoNickname ?? '',
                hotel?.property?.basicInformation?.brand?.id
              ),
              footerLinkDetails: getFooterDetails(hotel, clusterCode),
              mandatoryFeeObj: {
                amountPlusMandatoryFee: getAmountPlusMandatoryFeeDetails(hotel),
                mandatoryFee: getMandatoryFeeDetails(hotel),
                mandatoryFeeDescription: getMandatoryFeeDescription(hotel.property?.basicInformation?.descriptions),
                ...getMandatoryFeeMessages(),
              },
              brandDetails: {
                brandId: hotel.property?.basicInformation?.brand?.id,
                label: '',
                hasUniquePropertyLogo: hotel?.property?.basicInformation?.hasUniquePropertyLogo,
              },
              ribbonDetails: ribbonDetails,
              addScrimToImage: true,
            };
          }
        })
      : [];
    return {
      hotels: hotels,
      totalProperties: isPreview
        ? data?.searchLowestAvailableRatesByPropertyIds?.total ?? 0
        : data?.offersSearch.edges[0]?.node?.numProperties ?? 0,
    };
  };
  //modify DTT queriy propertycard data helper function.
  const modifyDTTPropertyCardData = (data: any) => {
    const propList = isPreview
      ? data?.search?.lowestAvailableRates?.searchByPropertyIds?.edges
      : data?.marketing?.offers?.search?.edges?.[0]?.node?.associatedPropertiesAndRates?.propertiesAndRates;
    const clusterCode = isPreview
      ? data?.search?.lowestAvailableRates?.searchByPropertyIds?.edges[0]?.node?.rates[0]?.rateCategory?.value
      : data?.marketing?.offers?.search?.edges?.[0]?.node?.clusterCode;
    const hotels = propList?.length
      ? propList.map((hotel: any) => {
          const {
            fullyRenovatedLabel,
            recentlyRenovatedLabel,
            newHotelLabel,
            adultsOnlyLabel,
            renovatedLobbyLabel,
            renovatedRoomsLabel,
          } = model || {};
          const basicInformation = isPreview
            ? hotel?.node?.property?.basicInformation
            : hotel?.property?.basicInformation || {};
          const isFullyRenovated = basicInformation?.isFullyRenovated;
          const isRecentlyRenovated = basicInformation?.isRecentlyRenovated;
          const hasRenovatedRooms = basicInformation?.hasRenovatedRooms;
          const newProperty = basicInformation?.newProperty;
          const isAdultsOnly = basicInformation?.isAdultsOnly;
          const newLobby = basicInformation?.newLobby;
          let ribbonDetails = null;

          if (isFullyRenovated) {
            ribbonDetails = {
              ribbonText: fullyRenovatedLabel,
              ribbonClass: 'fully-renovated-ribbon',
            };
          } else if (isRecentlyRenovated) {
            ribbonDetails = {
              ribbonText: recentlyRenovatedLabel,
              ribbonClass: 'recently-renovated-ribbon',
            };
          } else if (newProperty) {
            ribbonDetails = {
              ribbonText: newHotelLabel,
              ribbonClass: 'new-hotel-ribbon ribbon',
            };
          } else if (isAdultsOnly) {
            ribbonDetails = {
              ribbonText: adultsOnlyLabel,
              ribbonClass: 'adult-hotel-ribbon',
            };
          } else if (newLobby) {
            ribbonDetails = {
              ribbonText: renovatedLobbyLabel,
              ribbonClass: 'renovated-lobby-ribbon',
            };
          } else if (hasRenovatedRooms) {
            ribbonDetails = {
              ribbonText: renovatedRoomsLabel,
              ribbonClass: 'renovated-rooms-ribbon',
            };
          }
          if (isPreview) {
            return {
              id: hotel?.node?.property?.id ?? '',
              sid: hotel?.node?.property?.basicInformation?.marshaBrandCode ?? '',
              brandCode: hotel?.node?.property?.basicInformation?.brand?.id ?? '',
              titleDetails: getTitle(hotel?.node?.property, hotel?.node?.property?.basicInformation?.brand?.id),
              reviewsDetails: getReviewDetails(
                hotel?.node?.property,
                hotel?.node?.property?.basicInformation?.brand?.id,
                hotel?.node?.distance
              ),
              description: getDescriptionText(hotel?.node?.property?.basicInformation?.descriptions),
              images: getPropertyImages(hotel?.node?.property),
              tertiaryLinkDetails: generateDetailsPageURL(
                hotel?.node?.property?.seoNickname ?? '',
                hotel?.node?.property?.basicInformation?.brand?.id
              ),
              footerLinkDetails: getFooterDetails(hotel, clusterCode),
              mandatoryFeeObj: {
                amountPlusMandatoryFee: getAmountPlusMandatoryFeeDetails(hotel),
                mandatoryFee: getMandatoryFeeDetails(hotel),
                mandatoryFeeDescription: getMandatoryFeeDescription(hotel.property?.basicInformation?.descriptions),
                ...getMandatoryFeeMessages(),
              },
              brandDetails: {
                brandId: hotel?.node?.property?.basicInformation?.brand?.id,
                label: '',
                hasUniquePropertyLogo: hotel?.node?.property?.basicInformation?.hasUniquePropertyLogo,
              },
              addScrimToImage: true,
            };
          } else {
            return {
              id: hotel.property?.id ?? '',
              sid: hotel.property?.basicInformation?.marshaBrandCode ?? '',
              brandCode: hotel.property?.basicInformation?.brand?.id ?? '',
              titleDetails: getTitle(hotel.property, hotel?.property?.basicInformation?.brand?.id),
              reviewsDetails: getReviewDetails(
                hotel.property,
                hotel?.property?.basicInformation?.brand?.id,
                hotel?.distance
              ),
              description: getDescriptionText(hotel?.property?.basicInformation?.descriptions),
              images: getPropertyImages(hotel.property),
              tertiaryLinkDetails: generateDetailsPageURL(
                hotel?.property?.seoNickname ?? '',
                hotel?.property?.basicInformation?.brand?.id
              ),
              footerLinkDetails: getFooterDetails(hotel, clusterCode),
              mandatoryFeeObj: {
                amountPlusMandatoryFee: getAmountPlusMandatoryFeeDetails(hotel),
                mandatoryFee: getMandatoryFeeDetails(hotel),
                mandatoryFeeDescription: getMandatoryFeeDescription(hotel.property?.basicInformation?.descriptions), // toBeContinued
                ...getMandatoryFeeMessages(),
              },
              brandDetails: {
                brandId: hotel.property?.basicInformation?.brand?.id,
                label: '',
                hasUniquePropertyLogo: hotel?.property?.basicInformation?.hasUniquePropertyLogo,
              },
              ribbonDetails: ribbonDetails,
              addScrimToImage: true,
            };
          }
        })
      : [];
    return {
      hotels: hotels,
      totalProperties: isPreview
        ? data?.search?.lowestAvailableRates?.searchByPropertyIds?.total ?? 0
        : data?.marketing?.offers?.search?.edges?.[0]?.node?.numProperties ?? 0,
    };
  };
  const getTitle = (property: any, brandId: string) => {
    const seoNickname = property?.seoNickname ?? '';
    const detailsPageURL =
      brandId === 'RZ'
        ? `${RZ_HOTEL_DOMAIN}${basePath}/hotels/${seoNickname}/overview/`
        : `${basePath}/hotels/${seoNickname}/overview/`;
    const titleDetails = {
      title: property?.basicInformation?.name,
      titleAriaLabel: property?.basicInformation?.name,
      isTitleLink: true,
      titleClickCallback: () => {
        const detailsPage = detailsPageURL;
        setRecentlyViewedProperties(property);
        window.open(`${detailsPage}`, '_blank');
      },
      titleLink: detailsPageURL,
      titleClickTrackVal: `${model?.id}|${property?.id}|${EXTERNAL_CTA_TYPE}`,
    };
    return titleDetails;
  };
  const setRecentlyViewedProperties = (property: any) => {
    const name = property?.basicInformation?.name;
    const localViewed = localStorage.getItem('miRecentlyViewedProperties');
    const recentViewed: recentViewedPropertiesType = JSON.parse(
      localViewed
        ? localViewed
        : JSON.stringify({
            config: {
              maxCachedPropertiesLimit: '10',
              maxCachedPropertiesTab: '2',
              maxCachedPropertiesDesktop: '3',
              maxCachedPropertiesMobile: '2',
              maxCachedDaysLimit: '60',
            },
            recentlyViewedProperties: [],
          })
    );
    const isDuplicate =
      recentViewed?.recentlyViewedProperties?.length &&
      recentViewed.recentlyViewedProperties.find(item => item.name === name);

    if (!isDuplicate) {
      const obj = {
        name: name,
        address: name,
      };

      if (recentViewed && recentViewed?.recentlyViewedProperties.length >= 0) {
        if (recentViewed.recentlyViewedProperties.length >= RECENT_SEARCH_LIST_LIMIT) {
          recentViewed.recentlyViewedProperties.pop();
        }
        recentViewed.recentlyViewedProperties.unshift(obj);
      }

      localStorage.setItem('miRecentlyViewedProperties', JSON.stringify(recentViewed));
    }
  };
  const getDescriptionText = (descriptions: any) => {
    return descriptions?.find((desc: any) => desc?.type?.enumCode === descriptionToDisplayOnPropertyCard)?.text || '';
  };
  const getReviewDetails = (property: any, brandId: string, distance: any) => {
    const seoNickname = property?.seoNickname;
    const rating = property?.reviews?.stars?.count ?? 0;
    const reviewCount = property?.reviews?.numberOfReviews?.count ?? 0;
    const reviewUrl =
      brandId === 'RZ'
        ? `${RZ_HOTEL_DOMAIN}${basePath}/hotels/${seoNickname}/overview/`
        : `${basePath}/hotels/${seoNickname}/reviews/`;
    const distanceInMiles = getCalculatedDistance(
      distance ? distance * 1000 : distance,
      currentLocaleVal !== 'en-US',
      currentLocaleVal
    );
    const reviewDetails = {
      ...(rating !== 0 && { reviewsAvg: rating }),
      ...(reviewCount !== 0 && { reviewsText: `(${reviewCount} ${model?.storefrontPropertyReviews})` }),
      reviewsLink: reviewUrl,
      reviewsLabel: '',
      reviewsClickTrackValue: `${model?.id}|${property?.id}-${model?.storefrontPropertyReviews}|${EXTERNAL_CTA_TYPE}`,
      milesText:
        distanceInMiles !== null && distanceInMiles !== undefined
          ? `${distanceInMiles} ${model?.unitFromDestinationLabel}`
          : '',
    };
    return reviewDetails;
  };
  const getPropertyImages = (data: any) => {
    const photoGalleryObj = data?.media?.photoGallery;
    const propertyImageList: any = [];
    const propertyImageArray: any = [];
    let cauroselImages: any = [];
    const edgesList: any = [];

    if (photoGalleryObj) {
      Object.keys(photoGalleryObj).forEach((categoryKey: any) => {
        const propertyObject: any = [];
        if (categoryKey !== '__typename' && photoGalleryObj?.[categoryKey]) {
          propertyObject['categoryCode'] = categoryKey;
          propertyObject['photosObj'] = photoGalleryObj?.[categoryKey];
          propertyImageList.push(propertyObject);
        }
      });
    }
    if (data?.media?.primaryImage?.edges?.[0]?.node?.imageUrls) {
      const hotelViewObj: any = [];
      hotelViewObj['categoryCode'] = HOTEL_VIEW;
      hotelViewObj['photosObj'] = data?.media?.primaryImage;
      propertyImageList.unshift(hotelViewObj);
    }
    propertyImageList.map((edgeCollection: any) => {
      edgesList.push(edgeCollection?.photosObj?.edges);
      edgesList.map((photosList: any) => {
        photosList.map((imgNode: any) => {
          const wideImg = imgNode?.node?.imageUrls?.wideHorizontal;
          if (wideImg !== null && wideImg !== '') {
            propertyImageArray.push({
              defaultImageUrl: `${imageDomain}${wideImg}${imageProperties}`,
            });
            cauroselImages = Array.from(
              new Map(propertyImageArray.map((item: any) => [item.defaultImageUrl, item])).values()
            ).slice(0, 5);
          }
        });
      });
    });

    if (cauroselImages.length < 1) {
      const brandFallbackImageArray: any = {};
      brandFallbackImageArray['defaultImageUrl'] = data?.basicInformation?.brand?.photos?.[0]?.content?.[0]?.url;
      cauroselImages.push(brandFallbackImageArray);
    }
    return cauroselImages;
  };
  const generateDetailsPageURL = (seoNickname: string, brandId: string) => {
    const detailsPage =
      brandId === 'RZ'
        ? `${RZ_HOTEL_DOMAIN}${basePath}/hotels/${seoNickname}/overview/`
        : `${basePath}/hotels/${seoNickname}/overview/`;
    const footerlinks = {
      href: detailsPage,
      target: '_blank',
      custom_click_track_value: `${model?.id}|${model?.storefrontPropertyHotelDetails}|${EXTERNAL_CTA_TYPE}`,
      rel: 'noreferrer',
      className: 'm-link-tertiary-button outlet-resevation-link custom_click_track ',
      buttonCopy: `${model?.storefrontPropertyHotelDetails}`,
      isLink: true,
      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        (): Window | null => window.open(`${detailsPage}`, '_self');
      },
    };
    return footerlinks;
  };

  const getRatesNode = (hotel: any, category: string) => {
    if (isPreview) {
      if (showPoints) {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        return hotel?.node?.rates?.filter((obj: any) => {
          return obj?.rateCategory?.value === (category === 'rate' ? null : category == 'pointSaver' ? 'P17' : 'MRW');
        })[0];
      } else {
        return hotel?.node?.rates[0];
      }
    } else {
      if (showPoints) {
        const LARNode = Enable_DTT_queries
          ? hotel?.lowestAvailableRates?.edges?.[0]?.node?.rates
          : hotel?.lowestAvailableRateCollection?.edges;
        const rateObj = LARNode?.filter((obj: any) => {
          return Enable_DTT_queries
            ? obj?.rateCategory?.value === (category === 'rate' ? null : category == 'pointSaver' ? 'P17' : 'MRW')
            : obj?.node?.rateCategory?.value ===
                (category === 'rate' ? null : category == 'pointSaver' ? 'P17' : 'MRW');
        });
        return Enable_DTT_queries ? rateObj?.[0] : rateObj?.[0]?.node;
      } else {
        return Enable_DTT_queries
          ? hotel.lowestAvailableRates?.edges?.[0]?.node?.rates?.[0]
          : hotel.lowestAvailableRateCollection?.edges?.[0]?.node;
      }
    }
  };
  const getPriceOnToggleSelection = (hotel: any) => {
    let amount;
    if (Enable_DTT_queries) {
      const lowestAverageRate = hotel?.node?.rates?.[0]?.rateModes?.lowestAverageRate;
      amount = lowestAverageRate?.totalAmount;
    } else {
      amount =
        hotel?.node?.rates?.[0]?.rateAmounts?.[0]?.totalAmount ??
        hotel?.node?.rates?.[0]?.rateAmounts?.[0]?.amount?.origin;
    }
    return amount;
  };
  const getAmountPlusMandatoryFeeDetails = (hotel: any) => {
    const rateObj = getRatesNode(hotel, 'rate');
    const stayLength = rateObj?.lengthOfStay ?? 1;
    const rateStatus = rateObj?.status?.code ?? 'unavailable';
    let mandatoryFee;

    if (isPreview) {
      if (rateStatus === 'available' || rateStatus === 'AvailableForSale') {
        if (
          (acceptLanguage === 'en-US' ||
            acceptLanguage.toLocaleLowerCase() === 'ja-jp' ||
            acceptLanguage.toLocaleLowerCase() === 'en-gb' ||
            searchData?.countryCode === 'JP' ||
            searchData?.countryCode === 'GB') &&
          showPricesTax
        ) {
          // should add UK as well.
          mandatoryFee = getPriceOnToggleSelection(hotel);
        } else {
          if (
            (acceptLanguage.toLocaleLowerCase() === 'ja-jp' ||
              acceptLanguage.toLocaleLowerCase() === 'en-gb' ||
              searchData?.countryCode === 'JP' ||
              searchData?.countryCode === 'GB') &&
            stayLength <= 1
          ) {
            mandatoryFee = Enable_DTT_queries
              ? rateObj?.rateModes?.lowestAverageRate?.amount
              : rateObj?.rateAmounts?.[0]?.amount?.origin;
          } else if (stayLength > 1) {
            mandatoryFee = Enable_DTT_queries
              ? rateObj?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees
              : rateObj?.rateAmountsByMode?.lowestAverageNightlyRate?.amountPlusMandatoryFees?.origin ?? {};
          } else {
            mandatoryFee = Enable_DTT_queries
              ? rateObj?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees ??
                rateObj?.rateModes?.lowestAverageRate?.amount
              : rateObj?.rateAmounts?.[0]?.amountPlusMandatoryFees?.origin ?? rateObj?.rateAmounts?.[0]?.amount?.origin;
          }
        }
      }
    } else {
      if (rateStatus === 'available' || rateStatus === 'AvailableForSale') {
        if (stayLength > 1) {
          mandatoryFee = Enable_DTT_queries
            ? rateObj?.rateModes?.lowestAverageRate?.amountPlusMandatoryFees
            : rateObj?.rateAmountsByMode?.lowestAverageNightlyRate?.amountPlusMandatoryFees?.origin ?? {};
        } else {
          mandatoryFee = Enable_DTT_queries
            ? rateObj?.rateModes?.firstNightLowestRate?.amountPlusMandatoryFees
            : rateObj?.rateAmountsByMode?.firstNightLowestStay?.amountPlusMandatoryFees?.origin ?? {};
        }
      }
    }

    const totalPrice = Enable_DTT_queries
      ? mandatoryFee && mandatoryFee?.amount
        ? Math.round(mandatoryFee?.amount / Math.pow(10, mandatoryFee?.decimalPoint as number))
        : 0
      : mandatoryFee && mandatoryFee?.value
      ? Math.round(mandatoryFee?.value / Math.pow(10, mandatoryFee?.valueDecimalPoint as number))
      : 0;
    return totalPrice;
  };
  const getMandatoryFeeDetails = (hotel: any) => {
    const rateObj = getRatesNode(hotel, 'rate');
    const stayLength = rateObj?.lengthOfStay ?? 1;
    let mandatoryFeeDTT: any = {};
    if (Enable_DTT_queries) {
      if (stayLength > 1) {
        mandatoryFeeDTT = rateObj?.rateModes?.lowestAverageRate?.mandatoryFees;
      } else {
        mandatoryFeeDTT = rateObj?.rateModes?.firstNightLowestRate?.mandatoryFees;
      }
      mandatoryFeeDTT = {
        currency: mandatoryFeeDTT?.currency,
        value: mandatoryFeeDTT?.amount,
        valueDecimalPoint: mandatoryFeeDTT?.decimalPoint,
      };
    }
    const mandatoryFee = Enable_DTT_queries ? mandatoryFeeDTT : rateObj?.rateAmounts?.[0]?.mandatoryFees?.origin ?? {};
    return mandatoryFee;
  };
  const getMandatoryFeeDescription = (descriptions: any) => {
    const mandatoryFeeDescObj =
      descriptions?.length > 0
        ? descriptions?.filter((item: { type: { code: string } }) => {
            const code = item?.type?.code ?? '';
            if (code === RESORT_FEE_CODE) {
              isResort = true;
              isLACountyFee = false;
              return true;
            } else if (code === SURCHARGE_ORDINANCE_CODE) {
              isResort = false;
              isLACountyFee = true;
              return true;
            } else if (code === DESTINATION_FEE_CODE) {
              isResort = false;
              isLACountyFee = false;
              return true;
            }
            return false;
          })
        : [];
    return mandatoryFeeDescObj;
  };
  const getMandatoryFeeMessages = () => {
    const mandatoryFeeMessages = {
      title:
        model?.mandatoryFeeTitle ?? isResort
          ? model?.dailyResortFeeLabel
          : isLACountyFee
          ? model?.surchargeMandatoryFeeLabel
          : model?.dailyDestinationFeeLabel,
      feeDescription1: model?.includesLabel,
      feeDescription2:
        model?.feeDescription2 ?? isResort
          ? `${model?.resortLabel} ${model?.feeLabel}`
          : isLACountyFee
          ? model?.surchargeMandatoryFeeLabel
          : `${model?.destinationAmenityLabel} ${model?.feeLabel}`,
      viewRatesLabel: model?.propertyViewRates,
    };
    return mandatoryFeeMessages;
  };
  const getFooterDetails = (hotel: any, clusterCode: string) => {
    const offerSearchDates = JSON.parse(window.sessionStorage.getItem('OfferSearchDates') ?? '{}');
    const dateFlag =
      acceptLanguage === 'it-IT' ||
      acceptLanguage === 'fr-FR' ||
      acceptLanguage === 'pt-BR' ||
      acceptLanguage === 'es-ES' ||
      acceptLanguage === 'en-GB'
        ? true
        : false;

    if (offerSearchDates?.startDate && offerSearchDates?.endDate) {
      setFormValues(
        setDates({
          ...(formValues?.[DATES] ?? {}),
          fromDate: offerSearchDates?.startDate,
          toDate: offerSearchDates?.endDate,
        })
      );
    }

    const ratePage =
      (subdirectory && `/${subdirectory}`) +
      '/reservation/availabilitySearch.mi?' +
      `&numberOfRooms=${searchData?.quantity}&numberOfAdults=${
        Number(searchData?.numberInParty) - (searchData?.childAges?.length ?? 0)
      }&childrenCount=${searchData?.childAges?.length ?? ''}&childrenAges=${
        searchData?.childAges?.length ? searchData?.childAges.map((i: any) => (Number.isNaN(Number(i)) ? '0' : i)) : ''
      }` +
      '&flexibleDateSearchRateDisplay=false&useRewardsPoints=false&marrOfferId=' +
      offerId +
      '&fromDate=' +
      getDateFormatted(
        moment(offerSearchDates?.startDate || searchData?.startDate),
        acceptLanguage === 'zh-CN' ? 'YYYY-MM-DD' : dateFlag ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
      ) +
      '&toDate=' +
      getDateFormatted(
        moment(offerSearchDates?.endDate || searchData?.endDate),
        acceptLanguage === 'zh-CN' ? 'YYYY-MM-DD' : dateFlag ? 'DD/MM/YYYY' : 'MM/DD/YYYY'
      ) +
      '&corporateCode=' +
      clusterCode +
      `&clusterCode=${clusterCode === '0' ? 'none' : 'corp'}` +
      '&propertyCode=' +
      (isPreview ? hotel?.node?.property?.id : hotel.property?.id) +
      (searchData?.flexible === 'on' || mpoOffersFlexibleDate ? '&flexibleDateSearch=true' : '');

    const rateObj = getRatesNode(hotel, 'rate');

    let rate;
    if (
      isPreview &&
      (acceptLanguage === 'en-US' ||
        acceptLanguage.toLocaleLowerCase() === 'ja-jp' ||
        acceptLanguage.toLocaleLowerCase() === 'en-gb' ||
        searchData?.countryCode === 'JP' ||
        searchData?.countryCode === 'GB') &&
      showPricesTax
    ) {
      const mandatoryFee = getPriceOnToggleSelection(hotel);
      const amount = Enable_DTT_queries ? mandatoryFee?.amount : mandatoryFee?.value;
      const decimalPoint = Enable_DTT_queries ? mandatoryFee?.decimalPoint : mandatoryFee?.valueDecimalPoint;
      const totalPrice = mandatoryFee && amount ? Math.round(amount / Math.pow(10, decimalPoint as number)) : 0;

      rate = totalPrice;
    } else {
      rate = calculateRates(
        // isPreview ? hotel?.node?.rates : hotel.lowestAvailableRateCollection?.edges[0]?.node
        rateObj
      ).price;
    }

    const pointSaverStatus = getRatesNode(hotel, 'pointSaver')?.status?.code;
    const isPointSaver =
      (offersRespObj?.offers?.[0]?.clusterCode == 'P17' || offersRespObj?.edges?.[0].node?.clusterCode == 'P17') &&
      (pointSaverStatus === 'available' || pointSaverStatus === 'AvailableForSale')
        ? true
        : false;

    const footerlinks = {
      href: ratePage,
      target: '_self',
      ratesClickTrackValue: `${model.id}|${hotel?.property?.id}-${model?.bookNow}|${EXTERNAL_CTA_TYPE}`,
      rel: 'noreferrer',
      className: 'm-button-s m-button-primary custom_click_track reserve-cta-button',
      text:
        searchData?.flexible === 'on' || mpoOffersFlexibleDate ? `${model?.propertyViewRates}` : `${model?.bookNow}`,
      isLink: false,
      hasPrice: searchData?.flexible === 'on' || mpoOffersFlexibleDate ? false : rate > 0 ? true : false,
      priceAriaLabel: '',
      priceClickTrackValue: `${model.id}|${hotel?.property?.id}-${model?.storefrontPropertyPointsPerStay}|${EXTERNAL_CTA_TYPE}`,
      priceValue: rate ?? null,
      priceType:
        rate &&
        `${
          isPreview ? hotel?.node?.property?.basicInformation?.currency : hotel?.property?.basicInformation?.currency
        } / ${model?.storefrontPropertyNight}`,
      unavailableRateText: model?.rateUnavailable,
      points: showPoints
        ? getCommaSeparator(
            Enable_DTT_queries
              ? getRatesNode(hotel, 'points')?.rateModes?.pointsPerUnit?.points
              : getRatesNode(hotel, 'points')?.rateAmountsByMode?.pointsPerUnit?.points ?? '',
            acceptLanguage
          )
        : '',
      showPoints: showPoints,
      pointsType: model?.storefrontPropertyPointsPerStay,
      isPointSaver: isPointSaver,
    };
    return footerlinks;
  };
  const calculateRates = (LARNode: any) => {
    const stayLength = LARNode?.lengthOfStay ?? 1;
    const rateStatus = LARNode?.status?.code ?? 'unavailable';
    let price = 0;
    if (rateStatus === 'available' || rateStatus === 'AvailableForSale') {
      if (stayLength > 1) {
        const cashValue = Enable_DTT_queries
          ? LARNode?.rateModes?.lowestAverageRate?.amount?.amount
          : LARNode?.rateAmountsByMode?.lowestAverageNightlyRate?.amount?.origin?.value;
        const decimalValue = Enable_DTT_queries
          ? LARNode?.rateModes?.lowestAverageRate?.amount?.decimalPoint
          : LARNode?.rateAmountsByMode?.lowestAverageNightlyRate?.amount?.origin?.valueDecimalPoint;
        price = Math.round(cashValue / Math.pow(10, decimalValue as number));
      } else {
        const cashValue = Enable_DTT_queries
          ? LARNode?.rateModes?.firstNightLowestRate?.amount?.amount
          : LARNode?.rateAmountsByMode?.firstNightLowestStay?.amount?.origin?.value;
        const decimalValue = Enable_DTT_queries
          ? LARNode?.rateModes?.firstNightLowestRate?.amount?.decimalPoint
          : LARNode?.rateAmountsByMode?.firstNightLowestStay?.amount?.origin?.valueDecimalPoint;
        price = Math.round(cashValue / Math.pow(10, decimalValue as number));
      }
    }
    const points = Enable_DTT_queries ? LARNode?.rateModes?.pointsPerUnit?.points : LARNode?.pointsPerUnit?.points ?? 0;
    return {
      points: points,
      price: price,
    };
  };

  const handleSortBy = (event: any, sortOption: string): void => {
    setDataLoaderFlag(true);
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      //update session on sort
      let ariesOffer: any = sessionData?.cacheData?.data?.AriesOffer;
      ariesOffer = {
        ...ariesOffer,
        sortBy: sortOption,
      };
      let updatedSessionData: any = sessionData;
      updatedSessionData = {
        ...updatedSessionData,
        cacheData: {
          ...updatedSessionData?.cacheData,
          data: {
            ...updatedSessionData?.cacheData?.data,
            AriesOffer: ariesOffer,
          },
        },
      };
      updateGlobalData('sessionData', updatedSessionData);
      updateSessionObj(ariesOffer);
      setSortBy(sortOption);
      setCurrentPage(1);
    }
  };

  return (
    <StyledPropertiesListWrapper className={`${model?.styleclass}`}>
      <div className={`container offer-properties-list ${isPreview && 'propertiesPreviewMode'}`}>
        <div>
          <PropertiesListFilter
            model={model}
            availableBrands={availableBrands}
            availableCountries={availableCountries}
            availableStates={availableStates}
            availableCities={availableCities}
            handleApplyFilter={handleApplyFilter}
            selectedBrands={selectedBrands}
            selectedCountries={selectedCountries}
            selectedStates={selectedStates}
            selectedCities={selectedCities}
            brandFacets={brandFacets}
            countriesFacetList={countriesFacetList}
            statesFacetList={statesFacetList}
            citiesFacetList={citiesFacetList}
            handleClearAllFilters={handleClearAllFilters}
            isNewFacetsLoading={isNewFacetsLoading}
            variation={variation}
            isTaxSliderActive={showPricesTax}
            isPreview={isPreview}
          />
          {isPreview && (
            <Text
              copyText={model?.offersParticipatingPropertiesMessage}
              fontSize={Types.size.medium}
              customClass={'properties-list-preview-message'}
              element={Types.tags.paragraph}
            />
          )}
        </div>
        {dataLoaderFlag ? (
          <div className="pt-5 pb-5">
            <SkeletonOutletCardLoader />
          </div>
        ) : errorMessage ? (
          <AlertNotification errorMessage={errorMessage} className={'no-hotels-found alert'} />
        ) : (
          <>
            {!isPreview && (
              <div className="sort-by-wrapper mb-1">
                <div className="page-card-count">
                  <p className={clsx(isMobileViewPort ? 't-font-s' : 't-subtitle-l', 'pb-1', 'mb-0')}>
                    {pageCardCountInfo}
                  </p>
                </div>
                {((searchData?.latitude && searchData?.longitude) ||
                  searchData?.stateCode ||
                  searchData?.countryCode) &&
                  propertyCardData?.totalProperties &&
                  propertyCardData?.totalProperties > 1 && (
                    <SortByFilterComponent
                      handleSortBy={handleSortBy}
                      sortOptions={sortOptions}
                      currSortByOption={sortBy}
                      offersSortby={model?.sortByLabel ?? 'Sort by'}
                    />
                  )}
              </div>
            )}
            {propertyCardData?.hotels?.length &&
              propertyCardData.hotels.map((hotel: any) => {
                return (
                  <PropertyCard
                    {...hotel}
                    isMBOP={true}
                    trackingProperties={trackingProperties}
                    addScrimToImage={true}
                    hideReviews={hideReviews}
                    mpoFlexibleDate={searchData?.flexible === 'on' || mpoOffersFlexibleDate ? true : false}
                    isTaxesAndFeesEnabled={showPricesTax} // This flag used to show the Taxes & Mandatory Fees
                  />
                );
              })}
            <div className="pagination-container mt-5">
              <Pagination
                currentPage={currentPage}
                totalCount={propertyCardData.totalProperties ?? 0}
                pageSize={40}
                onPageChange={(page: number): void => onPageItemClick(page)}
                labels={paginationPanelLabel}
                seoFriendlyPagination={model.seoFriendlyPagination}
                queryParamName={PARAM_PAGENO}
                // model={model}
              />
            </div>
          </>
        )}
      </div>
    </StyledPropertiesListWrapper>
  );
};
export default PropertiesListWrapper;
